import { ListingTypeSchema } from "@redotech/redo-inventory-common/base-listing";
import { productFamilyIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const enableListing = {
  name: "enableListing" as const,
  input: z.object({
    listingType: ListingTypeSchema,
    productFamilyId: productFamilyIdFormat.schema,
  }),
  output: z.void(),
};
